export default "__VITE_ASSET__BOJMu_F1__"